import React, { useState, useEffect, useContext } from "react";
import BranchContext from "../context/branch";
import Truckwms from "../woodchip/truckwms";
import {
  GetprivilegePage,
  weightperhour,
  getMonitorECE,
  weightdetail,
  getWoodchipSumary,
  GetQueueDetail,
  GetQueuebranch,
  getdatabranch,
} from "../../services/wms";
import moment from "moment";
import DatePicker from "react-datepicker";
import Header from "./header";
import Headerproduct from "./headerproduct";
import Renderdata from "./cardbranch";
import ModalDetial from "./modaldetail";
import Modaldetailbranch from "./modaldetailbranch";
import Headerreport from "./headerreport";
import ReportCreate from "../chart/reportCreator";
import { toast } from "react-toastify";
import Reportwms from "../woodchip/reportwms";
import ReportToProduce from "../woodchip/reporttoproduce";
import HeaderSelect from "../woodchip/headerreport";
import Select2 from "./../common/selectoption";
const Managebranch = (props) => {
  const [branchid, setbranchid] = useState(0);
  const [reportId, setReportId] = useState("1");
  const [reportId2, setReportId2] = useState("0");
  const [proid, setproid] = useState(0);
  const [Id, setId] = useState(0);
  const [data, setData] = useState({});
  const [startDate, setstartDate] = useState(new Date());
  const [endDate, setendDate] = useState(new Date());
  const [queuelist, setqueuelist] = useState([]);
  const { currentBranch } = useContext(BranchContext);
  const [isOpen, setisOpen] = useState(false);
  const [list, setlist] = useState([]);
  const [perhour, setperhour] = useState([]);
  const [onProgress, setonProgress] = useState(false);
  const [onsubProgress, setonsubProgress] = useState(false);
  const [ckPermit, setckPermit] = useState(false);
  const [branchname, setbranchname] = useState([]);
  const [getbranch, setgetbranch] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, settotal] = useState({
    overtime: 0,
    waiting: 0,
    normal: 0,
    weightlog: 0,
    weightchip: 0,
    weightbark: 0,
  });
  useEffect(() => {
    if (!currentBranch) return;
    if (branchid == 0) return;

    const loadData = async () => {
      const { data: result } = await GetQueuebranch(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        branchid
      );

      if (result.status === "success") {
        setqueuelist(result.data.list);
        setId(0);
      } else {
        setqueuelist([]);
      }
    };
    loadData();
  }, [currentBranch, branchid, startDate]);

  useEffect(() => {
    if (!currentBranch) return;

    getdatabranch().then((result) => {
      setgetbranch(
        result.data.data.list.map((item) => {
          return {
            value: [item.branchid, item.branchname],
            label: item.branchname,
          };
        })
      );
    });
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (branchid == 0) return;
    if (Id == 0) return;
    const loadDataDetail = async () => {
      const { data: result } = await GetQueueDetail(Id, branchid);

      if (result.status === "success") {
        setlist(result.data.list);
      } else {
        setlist([]);
      }
    };
    loadDataDetail();
  }, [currentBranch, branchid, Id]);
  const handleChangeComId = (event) => {
    setbranchid(event[0]);
    setbranchname(event[1]);
    //setcomId(event.currentTarget.value);
    setPageNumber(1);
  };
  const handleChange = (event) => {
    setbranchid(event);
  };
  const handleReportChange = (event) => {
    setReportId(event);
    if (event == 4) {
      setReportId2(0);
    }
  };
  const handleProductChange = (event) => {
    setproid(event);
  };
  const handleChangStartDate = (event) => {
    setstartDate(event);
  };
  const handleChangEndDate = (event) => {
    setendDate(event);
  };

  const handleonClick = (event) => {
    setId(event);
    setisOpen(true);
  };
  const handleConfirm = () => {
    setisOpen(false);
  };
  const handleCancel = () => {
    setisOpen(false);
  };

  const disabledmenu = (event) => {
    setonProgress(event);
  };
  const disabledsubmenu = (event) => {
    setonProgress(event);
    setonsubProgress(event);
  };

  const handlebranchname = (event) => {
    setbranchname(event);
  };
  const handleSelectReport = (event) => {
    setReportId2(event);
  };
  if (!(currentBranch._id == "501")) {
    return <></>;
  }

  return (
    <>
      <Modaldetailbranch isOpen={isOpen} onCancel={handleCancel} list={list} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
            <i
              style={{
                fontFamily: "-apple-system",
                fontSize: "2rem",
                fontWeight: 1.5,
                lineHeight: 1.5,
                color: "#292b2c",
                backgroundColor: "yellow",
                // padding: "0 1em"
              }}
            >
              {branchname} <span></span>
            </i>
          </div>
        </div>
        <div className="row">
          <div className="col-auto">
            <i>
              วันที่ <span></span>
            </i>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
                className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>
        </div>

        {/* {reportId && (reportId == 1 || reportId == 2) && ( */}
        <div className="row">
          <div className="col-auto">
            <i>
              พื้นที่ <span></span>
            </i>
            <div className="mt-1 " style={{ marginTop: 20, marginBottom: 20 }}>
              <Header
                onChange={handleChange}
                disabled={onsubProgress}
                name={setbranchname}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4  col-sm-6 col-xs-12">
            <Select2
              label="ค้นหาสาขา HUB"
              data={getbranch}
              value={branchid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleChangeComId}
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="col-auto">
        
            <button className="btn btn-success ">ลงทะเบียนชั่งรถ</button>
          </div>

          <div>
            <button className="btn btn-success ">ลงทะเบียนรถบริษัท</button>
          </div>
        </div> */}
        {/* )} */}
        {/* {reportId && reportId == 1 && ( */}
        <div className="row mt-2">
          <div className="col-auto"></div>

          <div
            className="col-auto mb-2
          "
          >
            <div className="justify-content-center">
              <span
                className="badge bg-success"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ชั่งเข้า"} {total.waiting}
              </span>
            </div>
          </div>

          <div
            className="col-auto mb-2
          "
          >
            <div
              className="justify-content-center
          "
            >
              <span
                className="badge bg-info text-dark"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ชั่งออก"} {total.normal}
              </span>
            </div>
          </div>
          <div
            className="col-auto mb-2
          "
          >
            <div
              className="justify-content-center
          "
            >
              <span
                className="badge  bg-warning text-dark"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ลงทะเบียน"} {total.waiting}
              </span>
            </div>
          </div>
        </div>

        {/* )} */}
        <Renderdata
          list={queuelist}
          // product={proid}
          handleonClick={handleonClick}
          disabled={disabledsubmenu}
        />
      </div>
    </>
  );
};

export default Managebranch;
